/**
 * Dotenv in Create React App, a brief guide.
 *
 * - Dotenv is applied at build time
 * - Anything in the environment starting with NX_ will be loaded
 * - Anything in .env starting with NX_ will be loaded, and override the outer environment if there's a conflict
 * - Loaded variables are used at build time to replace process.env.SOME_NAME with the actual value, process.env does not exist in the bundle
 */

export const env = {
  // From .env
  API_URL: process.env.NX_API_URL || process.env.NX.NX_API_URL,
  NX_ADMIN_URL: process.env.NX_ADMIN_URL || process.env.NX?.NX_ADMIN_URL,

  B2C_AUTHORITY:
    process.env.NX_B2C_AUTHORITY || process.env.NX.NX_B2C_AUTHORITY,
  B2C_SIGNIN_POLICY:
    process.env.NX_B2C_SIGNIN_POLICY || process.env.NX.NX_B2C_SIGNIN_POLICY,
  B2C_RESET_PASSWORD_POLICY:
    process.env.NX_B2C_RESET_PASSWORD_POLICY ||
    process.env.NX.NX_B2C_RESET_PASSWORD_POLICY,
  B2C_EDIT_PROFILE_POLICY:
    process.env.NX_B2C_EDIT_PROFILE_POLICY ||
    process.env.NX.NX_B2C_EDIT_PROFILE_POLICY,
  CLIENT_ID: process.env.NX_CLIENT_ID || process.env.NX.NX_CLIENT_ID,
  SCOPES: process.env.NX_SCOPES || process.env.NX.NX_SCOPES,

  BUGSNAG_API_KEY:
    process.env.NX_BUGSNAG_API_KEY || process.env.NX?.NX_BUGSNAG_API_KEY,
  MIXPANEL_API_TOKEN:
    process.env.NX_MIXPANEL_API_TOKEN || process.env.NX?.NX_MIXPANEL_API_TOKEN,

  // From CI environment
  CI_BUILDNUMBER:
    process.env.NX_CI_BUILDNUMBER ||
    process.env.NX?.NX_CI_BUILDNUMBER ||
    'UNSET',
  CI_BUILDID:
    process.env.NX_CI_BUILDID || process.env.NX?.NX_CI_BUILDID || 'UNSET',
  CI_GIT_SHA:
    process.env.NX_CI_GIT_SHA || process.env.NX?.NX_CI_GIT_SHA || 'UNSET',

  NODE_ENV: process.env.NODE_ENV
}

window.env = env
